import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import '../../styles/_createMedOrder.scss';
import {
    useCreateMedOrderMutation,
    useGetPatientDetailsQuery,
} from '../../features/patient/patientService';
import PatientInformationHeader from '../../components/Patient/PatientInformationHeader';
import OrderMedicationForm from '../../components/Orders/OrderMedicationForm';
import PageTitle from '../../components/PageTitle';

const CreateMedOrder = () => {
    const { id: patientId = '' } = useParams();
    const navigate = useNavigate();
    const [createMedOrder, { isLoading: isCreatingMedOrder }] =
        useCreateMedOrderMutation();

    const { data: patientDetails } = useGetPatientDetailsQuery({
        id: patientId,
    });

    return (
        <div>
            <PageTitle
                title="Add New Medication"
                onClick={() => navigate(-1)}
            />

            <div className="mx-5">
                {patientDetails && (
                    <PatientInformationHeader
                        patient={patientDetails}
                        navigate={() => navigate(-2)}
                    />
                )}
                <OrderMedicationForm
                    toastMessage="Medication successfully added to Queue"
                    cancelButton={
                        <Button
                            onClick={() =>
                                navigate(
                                    `/patient/${patientId}/add-new-medication`,
                                )
                            }
                            className="me-4"
                            style={{
                                width: 120,
                                color: 'var(--hcrx-light-blue)',
                                borderColor: 'var(--hcrx-light-blue)',
                            }}
                            shape="round"
                        >
                            Cancel
                        </Button>
                    }
                    onSubmit={createMedOrder}
                    isSubmitting={isCreatingMedOrder}
                    submitLabel="Add to Queue"
                />
            </div>
        </div>
    );
};

export default CreateMedOrder;
